module.exports = __webpack_public_path__ + "static/novutek-bc42b34677e4eabb43b695219afca24e.webp";